import { useState } from "react";

import "antd/dist/antd.css";
import Header from "../../../Sidebar/header";
import Sidebar from "../../../Sidebar/sidebarAdmin";
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Stack } from "@mui/material";


import AllowanceCard from "./AllowanceCard";
import { items } from "./constant";
import { FaPlus } from "react-icons/fa";
import OverViewTable from "./OverViewTable";
import AddComponentForm from "./AddComponentForm";




const PayrollConfiguration = () => {
    const [menu, setMenu] = useState(false);
    const [open, setOpen] = useState(false);
    const [showOverview, setShowOverview] = useState(false);

    const handleClose = () => {
        setOpen(false)
    }


    const toggleMobileMenu = () => { setMenu(!menu); };


    return (
        <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
            <div className="page-wrapper">
                {/* Page Content */}
                <div className="content container-fluid">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">

                                <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between', mb: 1.5 }}>
                                    <h3 className="page-title">
                                        <span style={{ cursor: "pointer" }}>Payroll Configuration</span>
                                    </h3>
<Stack sx={{flexDirection:"row", gap:3}}>
 <Button
                                        variant="outlined"
                                        onClick={() => setShowOverview(true)}
                                        sx={{

                                            borderRadius: '8px', textTransform: 'capitalize'
                                        }}
                                    >
                                        Overview Payroll
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<FaPlus size={15} />}
                                        onClick={() => setOpen(true)}
                                        sx={{

                                            borderRadius: '8px', textTransform: 'capitalize'
                                        }}
                                    >
                                        Add Component
                                    </Button>
</Stack>
                                </Box>
                                <Box sx={{ p: 2, background: "#0f172a", minHeight: "100vh" }}>
                                    <Grid container spacing={3}>
                                        {items.map((item, index) => (
                                            <Grid item xs={12} md={6} lg={4} key={index}>
                                                <AllowanceCard
                                                    {...item}
                                                    onEdit={() => alert("Edit clicked")}
                                                    onDelete={() => alert("Delete clicked")}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
{showOverview &&
                                    <Box sx={{marginTop:2}}>
                                     <button  style={{ height: "25px", fontSize: "14px", paddingTop: "2px",  marginBottom:10 }}

          className=" btn-primary submit-btn1"
          onClick={(e) => {
            setShowOverview(false)
          }}>Back</button>
                                        <OverViewTable />
                                    </Box>
}
                                </Box>


                            </div>

                        </div>
                    </div>
                </div>

                <Dialog open={open} onClose={handleClose} >
                    <DialogTitle>Add Component</DialogTitle>
                    <DialogContent sx={{ maxWidth: 700 }}>
                        <AddComponentForm />
                    </DialogContent>
                </Dialog>

            </div>
        </div>
    );
};

export default PayrollConfiguration;
